import { render, staticRenderFns } from "./Secontcheck.vue?vue&type=template&id=5c874988&scoped=true&"
import script from "./Secontcheck.vue?vue&type=script&lang=js&"
export * from "./Secontcheck.vue?vue&type=script&lang=js&"
import style0 from "./Secontcheck.vue?vue&type=style&index=0&id=5c874988&scoped=true&lang=css&"
import style1 from "./Secontcheck.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c874988",
  null
  
)

export default component.exports